
import * as types from '../mutation-types'

export const state = {

  //Obs: topo e rodapé do modulo de documento
  // objetos
  paciente_imp : {}, //nececita dele para manter o histórico de impressão

  title: '',

  conteudo: '',

  // mostrar ou esconder objetos
  show : {
    topo: true,
    paciente: true,
    responsavel: false,
    escola: false,
    rodape_assinatura_user: true,
    assinatura_paciente: false,
    assinatura_reponsavel: false,
    assinatura_escola: false,
    outras_assinaturas: false
  }

}

//
export const actions = {

  // abrir o modal setando as configurações
  async openModalConfigImprimir({ dispatch, commit }, { paciente_id, title, conteudo }) {

    // console.log('chegou');

    if (paciente_id) {
          try {
            const { data } = await axios.get(`/api/pacientes-json/${paciente_id}`)
            if (data.id){
              commit(types.SET_IMPRIMIR,  { paciente_imp: data, title, conteudo } )
              $('#modal-config-imprimir').modal('show')
            }else{
              dispatch('alert/erroAoCarregar', 'impressão' ,{ root: true })
            }
          } catch (e) {
            dispatch('alert/erroAoCarregar', 'impressão' ,{ root: true })
          }
    }else {
        commit(types.SET_IMPRIMIR,  { paciente_imp: {}, title, conteudo } )
        $('#modal-config-imprimir').modal('show')
    }

  },

  async setPacienteIdImp({ dispatch, commit },  id){

    if (id) {
      try{
        const { data } = await axios.get(`/api/pacientes-json/${id}`)
        if (data.id) {
          commit(types.SET_PACIENTE_IMP, { paciente_imp: data })
        }else {
          dispatch('alert/erroAoCarregar', 'Paciente' ,{ root: true })
        }
      }catch(e){
          dispatch('alert/erroAoCarregar', 'Paciente' ,{ root: true })
      }
    }else {
        commit(types.SET_PACIENTE_IMP, { paciente_imp: {} })
    }

  },

  // para a tela de impressão
  openConfigImprimir() {

     $('#modal-config-imprimir').modal('show')

  },

  setConfigImprimir({ commit }, { show, title }){

      commit(types.SET_CONFIG_IMP, { show, title })

  }

}

//
export const mutations = {

  [types.SET_IMPRIMIR](state, { paciente_imp, title, conteudo }){
      state.paciente_imp = paciente_imp
      state.title = title
      state.conteudo = conteudo
  },

  [types.SET_PACIENTE_IMP](state, { paciente_imp }){
      state.paciente_imp = paciente_imp
  },

  [types.SET_CONFIG_IMP](state, { show, title }){
      state.show = show
      state.title = title
  },

  [types.LIMPAR_PACIENTE_IMP](state){
      state.paciente_imp = { escola:null, responsavel:null }
  }

}
















//










//



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/impressao.js